import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';

export type PlannerState = {
  loggedIn: boolean;
  plannerId: string;
  searchValue: string;
  currentPage: number;
};

export type PlannerActions = {
  setLoggedIn: (loggedIn: boolean) => void;
  setPlannerId: (plannerId: string) => void;
  setSearchValue: (searchValue: string) => void;
  setCurrentPage: (currentPage: number) => void;
  resetState: () => void;
};

const initialState: PlannerState = {
  loggedIn: false,
  plannerId: '',
  searchValue: '',
  currentPage: 1,
};

export const plannerStore: StateCreator<PlannerState & PlannerActions> = set => {
  return {
    ...initialState,

    setLoggedIn: (loggedIn: boolean) => {
      set(prevState => {
        return {
          ...prevState,
          loggedIn,
        };
      });
    },

    setPlannerId: (plannerId: string) => {
      set(prevState => {
        return {
          ...prevState,
          plannerId,
        };
      });
    },

    setSearchValue: (searchValue: string) => {
      set(prevState => {
        return {
          ...prevState,
          searchValue,
        };
      });
    },

    setCurrentPage: (currentPage: number) => {
      set(prevState => {
        return {
          ...prevState,
          currentPage,
        };
      });
    },

    resetState: () => {
      set(prevState => {
        return {
          ...prevState,
          loggedIn: false,
          plannerId: '',
          searchValue: '',
          currentPage: 1,
        };
      });
    },
  };
};

export const usePlannerStore = createAppStore(plannerStore, {
  usePersistentStore: true,
  persistentStoreName: 'RoomingListPlanner',
  useLocalStorage: true,
});
